const steps = [
  {
    title: 'Share what happened',
    text: 'Tell us your platform, FTM version, and what you were doing—install, upgrade, sync, or restore.',
  },
  {
    title: 'Follow tailored steps',
    text: 'We send instructions matched to Windows or Mac so you can move forward without guesswork.',
  },
  {
    title: 'Verify & protect',
    text: 'Once your tree opens cleanly, we help you confirm backups and set up good habits going forward.',
  },
];

export default function HowItWorks() {
  return (
    <section className="t7-section t7-section--white" id="how-it-works">
      <div className="container">
        <div className="t7-head t7-head--rail">
          <p className="t7-kicker">How we help</p>
          <h2 className="t7-title">From first message to working tree</h2>
          <p className="t7-lead">
            A simple three-step flow when you reach us through live chat.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className="relative bg-[#f4f7f5] border border-[#c4d4ca] rounded-[10px] p-5 sm:p-6 hover:border-[#40916c] transition-colors"
            >
              <span className="font-serif text-3xl text-[#c9956a] mb-3 block">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="font-serif text-xl text-[#152019] mb-2">{step.title}</h3>
              <p className="text-[#55665c] text-[15px] leading-relaxed m-0">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
